import { FitbitService } from "@/common/api.service";
import { FETCH_FITBIT_DATA, CREATE_FITBIT_DATA, RESET_STATE, SETUP_FITBIT_AUTH } from "./actions.type";
import { SET_FITBIT_DATA, SET_FITBIT_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    fitbitdata: [],
    fitbiterror: [],
  }
};

export const state = initialState();

const actions = {

  async [FETCH_FITBIT_DATA](context, slug) {
    return await FitbitService.get(slug).then((response) => {
      context.commit(SET_FITBIT_DATA, response.data)
      return response
    }).catch(({ response }) => {
      context.commit(SET_FITBIT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [CREATE_FITBIT_DATA](context, slug) {
    return await FitbitService.create(slug.slug, slug.params).then((response) => {
      return response.data
    }).catch(({ response }) => {
      context.commit(SET_FITBIT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [SETUP_FITBIT_AUTH](context, params) {
    return await FitbitService.setupAuth(params.patientId, params.authCode).then(response => {
      return response
    }).catch((error) => {
      context.commit(SET_FITBIT_ERROR, "Issue with setting authorization code")
      throw error
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_FITBIT_DATA](state, fitbitdata) {
    state.fitbitdata = fitbitdata
  },
  [SET_FITBIT_ERROR](state, error) {
    state.fitbiterror = error
  },
  [STATE_RESET]() {
    Object.assign(state, initialState())
  }

}

const getters = {
  fitbitdata(state) {
    return state.fitbitdata;
  },

}

export default {
  state,
  getters,
  actions,
  mutations
};